require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-redux-use-const-for-action-types.json") })
        }
      }, "path---front-end-libraries-redux-use-const-for-action-types");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-redux-use-const-for-action-types!./.cache/json/front-end-libraries-redux-use-const-for-action-types.json
// module id = 2116
// module chunks = 231608221292675